import React from 'react'
import { Carousel } from 'react-bootstrap'

export const ImageSlider = () => {
  return (
    <Carousel interval={2000} fade={true} controls={false} indicators={false} pause={false}>
      <Carousel.Item>
        <img src="/assets/img/principal-app/check-removebg-preview.png" alt="Carousel " />
      </Carousel.Item>
      <Carousel.Item>
        <img src="/assets/img/principal-app/dashboard-removebg-preview.png" alt="Carousel " />
      </Carousel.Item>
      <Carousel.Item>
        <img src="/assets/img/principal-app/ticket-pivot-removebg-preview.png" alt="Carousel " />
      </Carousel.Item>
      <Carousel.Item>
        <img src="/assets/img/principal-app/test-pdf-removebg-preview.png" alt="Carousel " />
      </Carousel.Item>
    </Carousel>
  )
}
